import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  bgColor?: 'white' | 'lightgray' | 'lime';
}
export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  bgColor = 'white'
}) => {
  const bgClass = bgColor === 'lightgray' ? 'bg-lightgray bg-opacity-30' : bgColor === 'lime' ? 'bg-lime' : 'bg-white';
  return <section className={`py-12 md:py-20 ${bgClass} ${className}`} data-id="element-146">
      <div className="container mx-auto px-4 md:px-12" data-id="element-147">{children}</div>
    </section>;
};